<template>
	<div class="user-setting">
		<div class="portrait">
			<a-upload
				name="file"
				list-type="picture-card"
				class="avatar-uploader"
				:show-upload-list="false"
				:headers="{
					token: getToken,
				}"
				:action="base_url + '/api/file/upload'"
				:before-upload="beforeUpload"
				@change="changeImg"
			>
				<template>
					<img
						v-if="user.avatar && pcAvatar"
						:src="base_url + user.avatar"
						alt="avatar"
					/>
					<img v-else :src="user.avatar" alt="avatar" />
				</template>
				<div v-if="!user.avatar">
					<a-icon :type="loading ? 'loading' : 'plus'" />
					<div class="ant-upload-text">上传头像</div>
				</div>
			</a-upload>
		</div>
		<div class="sysUser">
			<div class="row hp_cz_center">
				<div class="lable">昵称</div>
				<div class="val hp_cz_center_s user-name">
					<!-- <div>{{ user.name }}</div> -->
					<a-input v-model="user.nickName" />
					<!-- <a-icon style="font-size: 20px;" type="right" /> -->
				</div>
			</div>
			<div class="row hp_cz_center">
				<div class="lable">手机号</div>
				<div class="val hp_cz_center_s cursor-point" @click="toPage(0)">
					<div>{{ user.mobile }}</div>
					<a-icon style="font-size: 20px;" type="right" />
				</div>
			</div>
			<!-- <div class="row hp_cz_center">
        <div class="lable">账号解绑</div>
        <div class="val hp_cz_center_s">

      </div>-->
			<div class="row hp_cz_center">
				<div class="lable">账号解绑</div>
				<div class="val hp_cz_center_s cursor-point" @click="toPage(1)">
					<div>第三方登录</div>
					<a-icon style="font-size: 20px;" type="right" />
				</div>
			</div>
			<div class="row hp_cz_center">
				<div class="lable">所在地</div>
				<div class="val hp_cz_center_s" style="border:none">
					<a-select
						show-search
						placeholder="请选择所在地"
						option-filter-prop="children"
						style="width: 200px"
						:filter-option="filterOption"
						dropdownClassName="address"
						v-model="user.address"
					>
						<a-select-option
							v-for="(item, index) in marriagesArr"
							:key="index"
							:value="item.text"
							>{{ item.text }}</a-select-option
						>
					</a-select>
				</div>
			</div>
			<div class="editFooter">
				<a-button type="primary" @click="changeMember"
					>确定修改</a-button
				>
			</div>
		</div>
	</div>
</template>
<script>
import { getMemberDetail, editMember } from '@/api/user-center'
import { ls } from '@/utils/tool'
import { getToken } from '@/utils/auth'
function getBase64(img, callback) {
	const reader = new FileReader()
	reader.addEventListener('load', () => callback(reader.result))
	reader.readAsDataURL(img)
}
export default {
	data() {
		return {
			pcAvatar: true,
			sysUser: ls.get('sysUser'),
			user: {},
			loading: false,
			getToken: getToken(),
			marriagesArr: [
				{
					text: '八公山区',
					type: 'NATION_TYPE',
					value: '八公山区',
				},
				{
					text: '大通区',
					type: 'NATION_TYPE',
					value: '大通区',
				},
				{
					text: '凤台县',
					type: 'NATION_TYPE',
					value: '凤台县',
				},
				{
					text: '潘集区',
					type: 'NATION_TYPE',
					value: '潘集区',
				},
				{
					text: '寿县',
					type: 'NATION_TYPE',
					value: '寿县',
				},
				{
					text: '田家庵区',
					type: 'NATION_TYPE',
					value: '田家庵区',
				},
				{
					text: '谢家集区',
					type: 'NATION_TYPE',
					value: '谢家集区',
				},
			],
		}
	},
	created() {},
	mounted() {
		this.init()
	},
	methods: {
		async init() {
			var res = await getMemberDetail({
				memberId: this.sysUser.id,
			})
			console.log('res.data===', res.data)
			this.user = res.data
			if (this.user.avatar.indexOf('https://thirdwx.qlogo.cn') != -1) {
				this.pcAvatar = false
			}
		},
		changeImg(info) {
			console.log('info====', info)
			if (info.file.status === 'uploading') {
				this.loading = true
				return
			}
			if (info.file.status === 'done') {
				// Get this url from response in real world.
				this.defaultavatar = this.user.avatar
				this.user.avatar = info.file.response.data
				this.loading = false
				// getBase64(info.file.originFileObj, (imageUrl) => {
				//   console.log('imageUrl=====', imageUrl)
				//   this.user.avatar = imageUrl
				//   this.loading = false
				// })
			}
			if (info.file.status === 'error') {
				this.$message.error('上传图片失败！')
				this.loading = false
			}
		},
		async changeMember() {
			let data = { ...this.user }
			var res = await editMember(data)
			if (res.code == 200) {
				this.$message.success('信息修改成功')
			} else {
				this.$message.error(res.message)
				this.user.avatar = this.defaultavatar
			}
		},
		beforeUpload(file) {
			const isJpgOrPng =
				file.type === 'image/jpeg' || file.type === 'image/png'
			if (!isJpgOrPng) {
				this.$message.error('图片格式错误')
			}
			const isLt2M = file.size / 1024 / 1024 < 2
			if (!isLt2M) {
				this.$message.error('图片大小不能超过2MB!')
			}
			return isJpgOrPng && isLt2M
		},

		// handleChange(value) {
		//   this.user.address = value
		//   console.log(`selected ${value}`)
		// },
		// handleBlur() {
		//   console.log('blur')
		// },
		// handleFocus() {
		//   console.log('focus')
		// },
		filterOption(input, option) {
			return (
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
			)
		},

		toPage(num) {
			if (num == 0) {
				this.$router.push('/user-center/user-setting/setting-phone')
				return
			}
			this.$router.push('/user-center/user-setting/setting-login')
		},
	},
}
</script>
<style lang="less" scoped>
.user-setting {
	.portrait {
		margin-bottom: 30px;
		position: relative;
		overflow: hidden;
		margin-left: 340px;
		// margin-left: 1.9rem;
		img {
			width: 100%;
			border-radius: 50%;
		}
	}
	.sysUser {
		.row {
			font-size: 20px;
			margin-left: 200px;
			.lable {
				margin-right: 20px;
				width: 80px;
				color: #909399;
			}
			.val {
				color: #999999;
				width: 436px;
				border-bottom: 2px solid #ececec;
				padding: 23px 60px;
			}
			.user-name {
				.ant-input {
					width: 100%;
					height: 100%;
					border: none;
					color: #909399;
					padding: 0;
					font-size: 20px;
				}
			}
		}
	}
	.ant-select .ant-select-enabled {
		width: 100%;
	}
	.editFooter {
		text-align: center;
		margin-top: 30px;

		button {
			font-size: 20px !important;
			width: 379px;
			height: 52px;
			background: #0096fa;
			border-radius: 4px;
		}
	}
}
</style>
